import React from "react";

import { Avatar, CardHeader } from "@material-ui/core";

import { i18n } from "../../translate/i18n";

const TicketInfo = ({ contact, ticket, onClick }) => {
	return (
		<CardHeader
			onClick={onClick}
			style={{ cursor: "pointer" }}
			titleTypographyProps={{ noWrap: true }}
			subheaderTypographyProps={{ noWrap: true }}
			avatar={<Avatar src={contact?.profilePicUrl} alt="contact_image" />}
			title={
				<div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
					<span>{`${contact?.name || ""} #${ticket?.id || ""}`}</span>
					{ticket?.adName && (
						<span
							title={`Origem: Anúncio Meta Ads (${ticket.adName})`}
							style={{
								fontSize: "0.72rem",
								backgroundColor: "#1877F2",
								color: "#ffffff",
								borderRadius: 4,
								padding: "1px 7px",
								fontWeight: "bold",
								display: "inline-flex",
								alignItems: "center",
								gap: 4,
								boxShadow: "0 1px 2px rgba(24, 119, 242, 0.3)"
							}}
						>
							🎯 Ads: {ticket.adName}
						</span>
					)}
				</div>
			}
			subheader={
				ticket?.user &&
				`${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`
			}
		/>
	);
};

export default TicketInfo;
